
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { CheckCircle, Circle, Clock, Package, Truck } from "lucide-react";
import { format } from "date-fns";

interface OrderTimelineProps {
  order: {
    status: string;
    created_at: string;
    updated_at: string;
  };
}

const OrderTimeline = ({ order }: OrderTimelineProps) => {
  const timelineSteps = [
    { 
      status: 'pending', 
      label: 'Order Placed', 
      icon: Clock,
      date: order.created_at
    },
    { 
      status: 'processing', 
      label: 'Processing', 
      icon: Package,
      date: order.status === 'processing' ? order.updated_at : null
    },
    { 
      status: 'shipped', 
      label: 'Shipped', 
      icon: Truck,
      date: order.status === 'shipped' ? order.updated_at : null
    },
    { 
      status: 'delivered', 
      label: 'Delivered', 
      icon: CheckCircle,
      date: order.status === 'delivered' ? order.updated_at : null
    },
  ];

  const getCurrentStepIndex = () => {
    return timelineSteps.findIndex(step => step.status === order.status);
  };

  const currentStepIndex = getCurrentStepIndex();

  return (
    <Card>
      <CardHeader>
        <CardTitle>Order Timeline</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {timelineSteps.map((step, index) => {
            const Icon = step.icon;
            const isCompleted = index <= currentStepIndex;
            const isCurrent = index === currentStepIndex;
            
            return (
              <div key={step.status} className="flex items-center gap-3">
                <div className={`
                  flex items-center justify-center w-8 h-8 rounded-full border-2
                  ${isCompleted 
                    ? 'bg-green-500 border-green-500 text-white' 
                    : 'border-gray-300 text-gray-400'
                  }
                  ${isCurrent && !isCompleted ? 'border-blue-500 text-blue-500' : ''}
                `}>
                  <Icon className="h-4 w-4" />
                </div>
                
                <div className="flex-1">
                  <p className={`font-medium ${
                    isCompleted ? 'text-gray-900' : 'text-gray-500'
                  }`}>
                    {step.label}
                  </p>
                  {step.date && (
                    <p className="text-sm text-gray-500">
                      {format(new Date(step.date), 'MMM dd, yyyy HH:mm')}
                    </p>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
};

export default OrderTimeline;
